/* ==========================================================================
   AP-CHARGE · wires the ice voltage charge (see ap-charge.css) onto these
   places, and nothing else:
   - home: the showcase stat numbers, one after another in reading order;
   - home and product page: the accent words of the brands heading
     ("studios and institutions");
   - home: the accent words of the before / after heading ("after Adivaa");
   - product page: words marked with [data-ap-zap], i.e. the product type
     inside the title and "Adivaa Power" in the reels heading.

   Headings start the first time they are on screen. The stats restart whenever
   the slideshow swaps which numbers are showing, so every set runs its
   sequence from its first number. Loaded by theme.liquid on the home template
   and by the product hero section (ap-pdx-hero, ap-pdp-hero).
   ========================================================================== */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ok = window.CSS && CSS.supports &&
    CSS.supports('color', 'color-mix(in srgb, red, blue)') &&
    (CSS.supports('background-clip', 'text') || CSS.supports('-webkit-background-clip', 'text'));
  if (!ok) return;

  var HEADINGS = '.ap-brands-section :is(h1, h2, h3), .ap-ba-section h2';

  /* scope.querySelectorAll never returns scope itself; a reloaded section is the scope */
  var within = function (scope, sel) {
    var out = Array.prototype.slice.call(scope.querySelectorAll(sel));
    if (scope.matches && scope.matches(sel)) out.unshift(scope);
    return out;
  };

  /* restart the loop on a set of elements, staggered in the order given */
  var charge = function (els) {
    els.forEach(function (el, i) {
      el.style.setProperty('--zap-i', i);
      el.classList.remove('is-charging');
      void el.offsetWidth;                       // a reflow queues a fresh run
      el.classList.add('is-charging');
    });
  };

  var whenSeen = function (el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        fn();
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    io.observe(el);
  };

  /* reading order off the real layout: rows top to bottom, then left to right.
     Tops within 24px count as one row (the two stat columns align, not exactly). */
  var readingOrder = function (els) {
    return els
      .map(function (el) { return { el: el, r: el.getBoundingClientRect() }; })
      .sort(function (a, b) {
        return Math.abs(a.r.top - b.r.top) > 24 ? a.r.top - b.r.top : a.r.left - b.r.left;
      })
      .map(function (x) { return x.el; });
  };

  function headings(scope) {
    within(scope, HEADINGS).forEach(function (h) {
      if (h.getAttribute('data-ap-charge') === 'on') return;
      var t = [];
      h.querySelectorAll('b, strong').forEach(function (b) {
        /* word masks are inline-blocks, and background-clip:text never reaches
           glyphs inside one, so a split heading charges its word spans instead */
        var words = b.querySelectorAll('.ap-w-i');
        if (words.length) words.forEach(function (w) { t.push(w); });
        else t.push(b);
      });
      if (!t.length) return;
      h.setAttribute('data-ap-charge', 'on');
      t.forEach(function (el) { el.classList.add('ap-charge'); });
      whenSeen(h, function () { charge(t); });
    });
  }

  function stats(scope) {
    within(scope, '.ap-showcase-section').forEach(function (sec) {
      if (sec.getAttribute('data-ap-charge') === 'on') return;
      var nums = Array.prototype.slice.call(sec.querySelectorAll('[data-ap-stat] .ap-stat-n'));
      if (!nums.length) return;
      sec.setAttribute('data-ap-charge', 'on');
      nums.forEach(function (n) { n.classList.add('ap-charge'); });

      var seen = false, wait = null;
      var run = function () {
        var shown = nums.filter(function (n) { return !n.closest('[data-ap-stat]').hidden; });
        charge(readingOrder(shown));
      };
      whenSeen(sec, function () { seen = true; run(); });
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          if (!seen) return;
          window.clearTimeout(wait);
          wait = window.setTimeout(run, 30);        // one restart per slide change
        }).observe(sec, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
      }
    });
  }

  /* Marked words, wherever they sit: a [data-ap-zap] span holds exactly the
     words to charge (the product type inside the product title, "Adivaa
     Power" in the product page's reels heading). data-ap-zap="ink" keeps them
     resting in ink, the colour they already had, instead of the accent.
     Marks inside one heading start together, staggered like the accents. */
  function marked(scope) {
    var hosts = [], sets = [];
    within(scope, '[data-ap-zap]').forEach(function (el) {
      if (el.getAttribute('data-ap-charge') === 'on') return;
      el.setAttribute('data-ap-charge', 'on');
      var host = (el.parentNode && el.parentNode.closest && el.parentNode.closest('h1, h2, h3, h4, p')) || el;
      var k = hosts.indexOf(host);
      if (k < 0) { k = hosts.push(host) - 1; sets[k] = []; }
      var words = el.querySelectorAll('.ap-w-i');
      if (words.length) words.forEach(function (w) { sets[k].push(w); });
      else sets[k].push(el);
    });
    hosts.forEach(function (host, k) {
      sets[k].forEach(function (el) { el.classList.add('ap-charge'); });
      whenSeen(host, function () { charge(sets[k]); });
    });
  }

  var init = function (scope) { headings(scope); stats(scope); marked(scope); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
